module.exports = __webpack_public_path__ + "img/coiffeur_j_r_5662.8ab080d2.jpg";